/**
 * Processes and evaluates dynamic logical expressions.
 * @param {string|boolean} condition
 * @param {Object} context - Object with variables (e.g., { supplierNit: '123' }).
 * @returns {boolean}
 */
export const evaluateCondition = (condition, context = {}, extraContext = {}) => {
    const safeContext = { ...context, ...extraContext };

    if (condition === undefined || condition === null || condition === true || condition === "") return true;
    if (condition === false) return false;

    try {
        const sanitizedCondition = condition.replace(/{(\w+)}/g, (match, key) => {
            const value = safeContext[key];
            if (value === undefined) return 'undefined';
            return typeof value === 'string' ? `'${value}'` : value;
        });

        const runner = new Function(`return (${sanitizedCondition})`);
        return !!runner();
    } catch (error) {
        console.warn("Error en validación dinámica:", { condition, error });
        return false;
    }
};
